module.exports = __webpack_public_path__ + "img/08.363cda8c.jpg";